import React from 'react';
import { Link } from 'react-router-dom';
import { FaHeart, FaShoppingCart } from 'react-icons/fa';

function PostCard({ post, isFavorite, onToggleFavorite, onShare }) {
  return (
    <article className="post-card">
      <img src={post.image} alt={post.title} className="post-image" />
      <div className="post-content">
        <div className="post-meta">
          <span className="post-date">{post.date}</span>
          <span className="post-category">{post.category}</span>
        </div>
        <h3>{post.title}</h3>
        <p className="post-excerpt">{post.excerpt}</p>
        <div className="post-actions">
          <Link to={`/post/${post.id}`} className="btn btn-primary">
            <FaShoppingCart />
            Διαβάστε Περισσότερα
          </Link>
          <button 
            className="btn btn-secondary" 
            onClick={() => onShare(post.id)}
          >
            Μοιραστείτε
          </button>
          <button 
            className={`btn btn-favorite ${isFavorite ? 'active' : ''}`}
            onClick={() => onToggleFavorite(post.id)}
          >
            <FaHeart />
            {isFavorite ? 'Αγαπημένο' : 'Προσθήκη'}
          </button>
        </div>
      </div>
    </article>
  );
}

export default PostCard;